import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {app} from "@/app";
import {formatShopifyPrice} from "@/helpers";

export class Cart extends AbstractStorageModule {
  cart: null|Record<string, any> = null;

  get payload(): null|Record<string, any> {
    if(!this.cart) return null;

    return {
      checkout_token: this.cart?.token,
      currency: this.cart?.currency,
      order_total: formatShopifyPrice(this.cart?.total_price),
      line_items: this.cart?.items?.map((item) => this.getLineItemPayload(item)),
    }
  }

  getLineItemPayload(item: Record<string, any>) {
    return {
      product_id: item?.product_id,
      product_variant_id: item?.variant_id,
      sku: item?.sku,
      title: item?.title,
      final_price: formatShopifyPrice(item?.final_price),
      quantity: item?.quantity,
      contents: item?.contents,
    };
  }

  getLineItemSimplifiedPayload(item: Record<string, any>) {
    return {
      product_id: item?.product_id,
      product_variant_id: item?.variant_id,
      quantity: item?.quantity,
    };
  }

  resolve() { }

  fetchCart(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const url = `${app.storage.shopify.shop.routesRoot}cart.js`;
      fetch(url, {method: 'GET', headers: { 'Content-Type': 'application/json' }}).then(response => {
        response.json().then(data => {
          this.cart = data;
          resolve(true)
        });
      }).catch((error) => {
        reject(error);
      })
    });
  }

  updateCartAttributes(attributes: Record<string, string|number|boolean|null>): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const url = `${app.storage.shopify.shop.routesRoot}cart/update.js`;
      fetch(url, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes})
      }).then(response => {
        resolve(true);
      }).catch((error) => {
        reject(error);
      })
    });
  }
  //
}
